'use client'
import React, { useRef, useEffect } from 'react'
import { Hero, Footer } from '../../../components'
import styles from './privacypolicy.module.css'
import { privacypolicytitles, allprivacypolicies } from '../../../utils/index'

const PrivacyPolicy = () => {
  const itemRefs = useRef([])

  useEffect(() => {
    if (window.location.hash) {
      const hash = window.location.hash.substring(1)
      const index = helpcentertitle.findIndex(
        (item) => item.title.toLowerCase().split(' ').join('-') === hash
      )
      if (index !== -1 && itemRefs.current[index]) {
        itemRefs.current[index].scrollIntoView({
          behavior: 'smooth',
        })
      }
    }
  }, [])

  const handleClick = (title, index) => {
    const formattedTitle = title.toLowerCase().split(' ').join('-')
    window.location.hash = `#${formattedTitle}`
    itemRefs.current[index].scrollIntoView({
      behavior: 'smooth',
    })
  }

  return (
    <div className={styles.privacycontainer}>
      <Hero>
        <button className={styles.herobtn}>our privacy policy</button>
        <p className={styles.herotitle}>CirclePlug Privacy</p>
        <p className={styles.herodescription}>
          We care about your privacy Your privacy is important to us
        </p>
      </Hero>
      <div className={styles.maincontentcontainer}>
        <div>
          <div className={styles.maincontentcontainerwrapper}>
            <div className={styles.termsofservicemaincontent}>
              <div className={styles.termsofservicemaincontenttop}>
                <p>Our Privacy Policy</p>
                <p>
                  Welcome to Circleplug! This privacy Policy statement provides
                  information about the personal information that CirclePlug
                  (‘we, us’) collects and how we use and protect your personal
                  information. By using the app/website, you agree to the
                  practices described in this policy. 
                </p>
              </div>
              <div className={styles.termsofservicemaincontenttop}>
                <p>Definitions</p>
                <p>
                  {`‘Data’ means collectively all information that you submit to
                  CirclePlug Limited via the Website/App. This definition
                  incorporates, where applicable, the definitions provided in
                  the applicable Data Protection Laws.‘Cookies’ means a small
                  text file placed on your computer by this Website when you
                  visit certain parts of the Website/App and/or when you use
                  certain features of the Website/App. Details of the cookies
                  used by this Website are set out in the Cookies Policy`}
                  <br />{' '}
                  {`‘Data Protection Laws’ means any applicable law
                  relating to the processing of personal Data, including but not
                  limited to the NDPR, and any national implementing and
                  supplementary laws, regulations, and secondary legislation.`}
                  <br />
                  {`‘NDPR’ means the Nigeria Data Protection Regulation.`}
                  <br />
                  {`‘Circleplug’ / we or us means Circleplug a flagship product of
                  Shypes Integrated Services Limited, a company incorporated in
                  Nigeria with registered number 1199010.`}{' '}
                  <br />{' '}
                  {`‘User or you’
                  means any third party that accesses the Website and is not
                  either (i) employed by Circleplug Limited and acting in the
                  course of their employment or (ii) engaged as a consultant or
                  otherwise providing services to Circleplug Limited and
                  accessing the Website in connection with the provision of such
                  services; and‘Website/App’ means the website that you are
                  currently using, www.circleplug.com, and any sub-domains of
                  this site unless expressly excluded by their own terms and
                  conditions.`}
                </p>
              </div>
              <div className={styles.termsofservicemaincontentbottom}>
                <div className={styles.termsofservicemaincontentbottomleft}>
                  <ul className={styles.termslists}>
                    {privacypolicytitles.map(({ id, title }, index) => (
                      <li
                        key={id}
                        className={styles.termlist}
                        onClick={() => handleClick(title, index)}
                      >
                        {title}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className={styles.termsofservicemaincontentbottomright}>
                  {allprivacypolicies.map(
                    ({ id, title, description, description2, items }, index) =>
                      description2 ? (
                        <div
                          key={id}
                          className={styles.services}
                          ref={(item) => (itemRefs.current[index] = item)}
                        >
                          <p className={styles.servicetitle}>{title}</p>
                          <div className={styles.personalinformation}>
                            <div>
                              <p className={styles.servicedescription}>
                                {description}
                              </p>
                              <ul
                                className={
                                  styles.personalinformationdescription
                                }
                              >
                                {items.map((item, i) => (
                                  <li key={i}>{item}</li>
                                ))}
                              </ul>
                            </div>
                            <p className={styles.servicedescription}>
                              {description2}
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div
                          key={id}
                          className={styles.services}
                          ref={(item) => (itemRefs.current[index] = item)}
                        >
                          <p className={styles.servicetitle}>{title}</p>
                          <p className={styles.servicedescription}>
                            {description}
                          </p>
                        </div>
                      )
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className={styles.emptycontent}></div>
          <div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy
